import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

const routeRecord: RouteRecordRaw = {
  name: 'client.financial',
  path: 'financial',
  redirect: { name: 'client.financial.ledger' },
  meta: {
    roles: [Roles.Client],

    supportedPlatforms: ['desktop', 'mobile', 'native'],
    excludeEnv: [],
  },
  children: [
    {
      name: 'client.financial.ledger',
      path: 'ledger',
      component: () => import('src/client/pages/financial/ClientLedger.vue'),
      meta: {
        roles: [Roles.Client],

        supportedPlatforms: ['desktop', 'mobile', 'native'],
        excludeEnv: [],
      },
    },
    {
      name: 'client.financial.finance',
      path: 'finance',
      component: () =>
        import('src/client/pages/financial/ClientFamilyFinance.vue'),
      meta: {
        roles: [Roles.Client],

        supportedPlatforms: ['desktop', 'mobile', 'native'],
        excludeEnv: [],
      },
    },
    {
      name: 'client.financial.yearend',
      path: 'yearend',
      component: () =>
        import('src/client/pages/financial/ClientFamilyYearEnd.vue'),
      meta: {
        roles: [Roles.Client],

        supportedPlatforms: ['desktop', 'mobile', 'native'],
        excludeEnv: [],
      },
    },
  ],
}

export default routeRecord
